import * as Redux from 'redux'
import thunk from 'redux-thunk'
import apiMiddleware from 'assets/js/apiMiddleware'
import Login from './reducers/Login'
import CustomerService from './reducers/CustomerService'
import Merge from './reducers/Merge'
import Prints from './reducers/Prints'
import SidebarCollapse from './reducers/SidebarCollapse'
import UserRole from './reducers/UserRole'

import { loadAssitances, loadAssistanceReports } from 'assets/js/assitances'
import { getToken } from 'assets/js/auth'

const composeEnhancer =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || Redux.compose

const reducers = Redux.combineReducers({
  Login,
  CustomerService,
  Merge,
  Prints,
  SidebarCollapse,
  UserRole
})
const assitances = loadAssitances()
const assistancesReport = loadAssistanceReports()

const { username, clinicId, id, role, name } = localStorage

const token = getToken()

const initialState = {
  Login: {
    token,
    user: { username, clinicId, id, role, name },
    loadingUser: false,
    isAuthenticated: !!token
  },
  CustomerService: {
    loading: false,
    customerService: assitances,
    lastGeneratedReport: assistancesReport
  }
}
const middleWares = [thunk, apiMiddleware]

const store = Redux.createStore(
  reducers,
  initialState,
  composeEnhancer(Redux.applyMiddleware(...middleWares))
)

export default store
